module.exports = __webpack_public_path__ + "img/02学科竞争报告.01dbcd4a.png";